import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, FormControlLabel, Checkbox, Alert } from '@mui/material';
import { createUser, updateUser, getMe } from '../../controllers/auth.controller';

const UserForm = ({ initialData, onClose }) => {
  const [form, setForm] = useState({ fullName: '', email: '', phone: '', password: '', role: 'viewer' });
  const [me, setMe] = useState(null);

  const [loadingMe, setLoadingMe] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    let mounted = true;

    const loadMe = async () => {
      try {
        setLoadingMe(true);
        setErrorMsg("");
        const res = await getMe();
        if (mounted) setMe(res);
      } catch (err) {
        console.error("getMe error:", err);
        if (mounted) setErrorMsg(err?.response?.data?.message || "خطا در دریافت اطلاعات کاربر جاری");
      } finally {
        if (mounted) setLoadingMe(false);
      }
    };

    loadMe();

    if (initialData) {
      setForm((prev) => ({
        ...prev,
        ...initialData,
        password: "",
        canManageSubjects: !!initialData.canManageSubjects,
      }));
    } else {
      // reset when creating new
      setForm({
        fullName: "",
        email: "",
        phone: "",
        password: "",
        role: "viewer",
        canManageSubjects: false,
      });
    }

    return () => {
      mounted = false;
    };
  }, [initialData]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      setErrorMsg("");

      // نمونه‌ی ولیدیشن ساده (اختیاری ولی مفید)
      if (!form.fullName?.trim()) return setErrorMsg("نام کامل را وارد کنید");
      if (!form.email?.trim()) return setErrorMsg("ایمیل را وارد کنید");
      if (!initialData && !form.password?.trim()) return setErrorMsg("برای کاربر جدید رمز عبور لازم است");

      if (initialData) {
        await updateUser(initialData._id, form);
      } else {
        await createUser(form);
      }

      onClose();
    } catch (err) {
      console.error("submit error:", err);
      setErrorMsg(err?.message || "خطا در ذخیره کاربر");
    }
    finally {
      setSubmitting(false);
    }
  };

  const availableRoles = me?.role === "admin" ? ["admin", "editor", "viewer"] : ["viewer"];


  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{initialData ? "ویرایش کاربر" : "کاربر جدید"}</DialogTitle>

      <DialogContent>
        {!!errorMsg && <Alert severity="error">{errorMsg}</Alert>}

        <TextField
          fullWidth
          margin="dense"
          label="نام کامل"
          name="fullName"
          value={form.fullName}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="dense"
          label="ایمیل"
          name="email"
          value={form.email}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="dense"
          label="شماره تلفن"
          name="phone"
          value={form.phone}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="dense"
          label="رمز عبور"
          type="password"
          name="password"
          value={form.password}
          onChange={handleChange}
          helperText={initialData ? "اگر نمی‌خواهید تغییر کند، خالی بگذارید." : ""}
        />

        <TextField
          select
          fullWidth
          margin="dense"
          label="نقش"
          name="role"
          value={form.role}
          onChange={handleChange}
          disabled={loadingMe || !me}
        >
          {availableRoles.map((role) => (
            <MenuItem key={role} value={role}>
              {role}
            </MenuItem>
          ))}
        </TextField>

        {me?.role === "admin" && (
          <FormControlLabel
            sx={{ mt: 1 }}
            control={
              <Checkbox
                checked={!!form.canManageSubjects}
                onChange={(e) => setForm((prev) => ({ ...prev, canManageSubjects: e.target.checked }))}
              />
            }
            label="دسترسی مدیریت بیماران"
          />
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>انصراف</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={submitting}>
          {submitting ? "در حال ذخیره..." : "ذخیره"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserForm;
